namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogAdmFunkcniMistoDeleteEkonini extends GContentBase {
        private funkcniMista: string[];
        private openFromDetail: boolean;

        prepareContent() {
            this.init();
        }

        private init() {
            this.title = "jres:33000876" //RC 33000876 : Smazání ekoinicializace pro funkční místa
            this.createActions();
            this.createFormEl();
            this.createCommandBar();
        }

        private createActions() {
            this.actions.addRange({
                actOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.actOK();
                    }
                },
                actClose: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.close();
                    }
                }
            })
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar(["actClose*", "actOk!"]))
        }

        private createFormEl() {
            const form = new Gordic.Forms.Form({
                name: "form-delete-ekonini",
                customClass: "form-delete-ekonini",
                layoutDescriptor: "L1M1S1, L-12-12-0, M-12-12-0, S-12-12-0"
            }).addRow(this.openFromDetail == true ? "jres:32131054" : "jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun;model.ixs_fun_txt<=value.nazev",
                validators: [new Gordic.Validators.Required({
                    stopping: true
                })],
                flag: "required",
                itemWidth: (this.openFromDetail == true) ? undefined : "",
                multi: (this.openFromDetail == true) ? false : true,
                dropdown: false,
                initialValue: (this.openFromDetail == true) ? { ixs_fun: this.funkcniMista[0] } : this.funkcniMista.map((value) => ({ ixs_fun: value })),
                disabled: this.openFromDetail == true
            })
                .addRow().addField("gcheck", { //RC 33000867 : Všechny fáze
                    name: "all_faze",
                    label: "jres:33000867",
                    customClass: "gcheck-switch",
                    initialValue: true,
                    change: (ev, ctx) => {
                        const field = this.findFields("faze");
                        field.gfield("setValidators", ctx.value == true ? [] : [new Gordic.Validators.Required({ stopping: true })])
                        field.gfield(ctx.value == true ? "disable" : "enable");
                    }
                })
                .addRow("jres:33000698").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                    name: "faze",
                    model: "model.faze=value.faze",
                    disabled: true,
                    dropdown: false,
                    multi: true,
                    itemWidth: ""
                })
            $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private actOK() {
            const form = this.findForms("form-delete-ekonini");
            if (form.gform("isValid")) {
                this.dialogs.confirmDangerous("jres:33000257", "jres:33000877").on("yes", () => { //RC 33000877 : Opravdu si přejete smazat ekonomickou inicializaci. Takto akce již nejde zvrátit, proto ji pečlivě zvažte. 
                    const result: any = {};
                    form.findFields().gfield("model", "collect", result);
                    const callObj: { funkcniMista: string[], faze: string[] } = { funkcniMista: [], faze: [] }
                    callObj.funkcniMista = (this.openFromDetail == true) ? [result.ixs_fun] : result.ixs_fun;
                    if (result.all_faze == false) 
                        callObj.faze = result.faze
                    this.beginOperation();
                    this.isl.AdmFunkcniMisto.deleteEkoinit(callObj).get().then((successIxsFun) => {
                        if (this.openFromDetail == true) {
                            this.notification("add", {
                                title: "jres:33000878", //RC 33000878 : Smazání ekoinicializace
                                content: "jres:33000879", //RC 33000879 : Smazání ekoinicializace proběhlo úspěšně.
                                state: "success",
                                icon: "gi-settings"
                            })
                        } else {
                            const resultstring: string[] = [];
                            successIxsFun.forEach((item) => {
                                const index = result.ixs_fun.indexOf(item);
                                    resultstring.push(`${result.ixs_fun_txt[index]}`)
                            })
                            let message = "";
                            if (successIxsFun.length > 0)
                                message = `<b>jres:33000880</b> <br /> ${resultstring.join(', ')}<br /><br />` //RC 33000880 : Úspěšně smazaná ekoinicializace:
                            this.notification("add", {
                                title: "jres:33000878", //RC 33000869 : Smazání uživatelského nastavení
                                content: message,
                                state: "success",
                                icon: "gi-settings"
                            })
                        }
                        this.close()
                    }).catch((ex) => {
                        this.notification("add", {
                            title: "jres:33000878", //RC 33000869 : Smazání uživatelského nastavení
                            content: "jres:33000881", //RC 33000881 : Chyba při mazání ekoinicializace.
                            state: "error",
                            icon: "gi-settings"
                        })
                    }).always(() => { this.endOperation() })
                })
            }
        }
    }
}